import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "form__journey-time d-flex justify-content-between" }
const _hoisted_2 = { class: "font-big font-weight-400 font-style-form-items" }
const _hoisted_3 = { class: "font-big font-weight-400 font-style-form-items" }
const _hoisted_4 = {
  key: 0,
  class: "form__journey-distance d-flex justify-content-between"
}
const _hoisted_5 = { class: "font-big font-weight-400 font-style-form-items" }
const _hoisted_6 = { class: "font-big font-weight-40 font-style-form-items" }
const _hoisted_7 = { class: "form__journey-price d-flex justify-content-between align-items-baseline" }
const _hoisted_8 = { class: "font-big font-weight-400 font-style-form-items" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('duration')), 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.data.duration.hours) + " " + _toDisplayString(_ctx.$t('shortened_hours')) + " " + _toDisplayString(_ctx.data.duration.minutes) + " " + _toDisplayString(_ctx.$t('shortened_minutes')), 1)
    ]),
    (_ctx.data.distance)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('distance')), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.data.distance) + " km. ", 1)
        ]))
      : _createCommentVNode("", true),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "hr-line m-2 mb-3" }, null, -1)),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('price')), 1),
      _createElementVNode("h4", null, _toDisplayString(_ctx.data.price) + " € ", 1)
    ])
  ], 64))
}